<template lang="pug">
  div
    form.w-full.max-w-xl.mt-6(v-on:submit="sendRequest")
      .flex.flex-wrap.-mx-3
        .w-full.px-3
          label(for='address') Address/Hostname
          input#address(placeholder='k.io' type="text" v-model="address")
          p.text-gray-600.text-xs.italic Both IP addresses and hostnames are supported.
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
    div.text-gray-100.text-sm.font-mono.bg-black.rounded.p-4.mt-6(v-if="response || hasError")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div.flex(v-else v-for="line in processedLines")
        div.text-gray-600.mr-2(v-if="line.key") {{line.key}}:&nbsp;
        div {{line.value}}
</template>
<style lang="postcss" scoped></style>
<script>
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  data() {
    return {
      address: "",
      response: null,
    };
  },
  computed: {
    searchParams() {
      return new URLSearchParams({ query: this.address });
    },
    processedLines() {
      if (this.response === null) {
        return null;
      }
      let passedComment = false;
      return this.response.map((line) => {
        if ((!passedComment && line.includes(">>>")) || line.includes("--")) {
          passedComment = true;
        }
        if (line.match(/^(?![%#])[a-zA-Z0-9\s\-_/]{1,40}:/) && !passedComment) {
          const split = line.split(":");
          return {
            key: split[0],
            value: split.slice(1, split.length).join(":"),
          };
        } else {
          return { value: line };
        }
      });
    },
  },
  methods: {
    sendRequest(e) {
      this.loading = true;
      this.response = null;
      e.preventDefault();
      this.clearError();
      fetch(`${this.selectedHost}/v1/whois/lookup?${this.searchParams}`, {
        method: "GET",
      })
        .then((resp) => {
          this.loading = false;
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          if (this.hasError) {
            this.setError(json.error.description);
          } else {
            this.response = json.response;
          }
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to lookup WHOIS, an error occurred");
        });
    },
  },
};
</script>
